import React, { useState } from 'react';
import './FAQ.css';

const FAQ = ({ userEvent }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqItems = [
    {
      question: "What time does the ceremony start?",
      answer: "The ceremony will begin promptly at 4:00 PM. We recommend arriving 30 minutes early to allow time for parking and seating."
    },
    {
      question: "What is the dress code?",
      answer: "The dress code is formal/semi-formal. We suggest suits and dresses, but please wear something you feel comfortable in. The venue is outdoors, so consider appropriate footwear."
    },
    {
      question: "Is there parking available at the venue?",
      answer: "Yes, complimentary parking is available at the venue. There will be attendants to guide you to the designated parking areas."
    },
    {
      question: "Can I bring a plus one?",
      answer: "Due to venue capacity limitations, we can only accommodate the guests named on your invitation. Please refer to your invitation for the exact number of seats reserved for you."
    },
    {
      question: "Are children welcome?",
      answer: "While we love your little ones, our wedding will be an adults-only celebration. We hope this gives all parents an opportunity to let loose and enjoy the evening!"
    },
    {
      question: "Will the ceremony and reception be indoors or outdoors?",
      answer: "The ceremony will be held outdoors in the garden area (weather permitting), and the reception will be in the grand ballroom. We have a contingency plan for the ceremony in case of inclement weather."
    },
    {
      question: "Do you have a wedding registry?",
      answer: "Your presence at our wedding is the greatest gift of all. However, if you wish to honor us with a gift, we have created a registry at [Registry Name] or you may contribute to our honeymoon fund."
    },
    {
      question: "Is the venue wheelchair accessible?",
      answer: "Yes, the venue is fully wheelchair accessible with ramps and elevators available."
    }
  ];

  const renderHoustonFaqItems = () => {
    return faqItems.map((item, index) => (
      <div
        className={`accordion-item ${activeIndex === index ? 'active' : ''}`}
        key={index}
      >
        <div
          className="accordion-header"
          onClick={() => toggleAccordion(index)}
        >
          <h3>{item.question}</h3>
          <span className="accordion-icon"></span>
        </div>
        <div className="accordion-content">
          <p>{item.answer}</p>
        </div>
      </div>
    ));
  };

  const renderCancunFaqItems = () => {
    return faqItems.map((item, index) => (
      <div
        className={`accordion-item ${activeIndex === index ? 'active' : ''}`}
        key={index}
      >
        <div
          className="accordion-header"
          onClick={() => toggleAccordion(index)}
        >
          <h3>{item.question}</h3>
          <span className="accordion-icon"></span>
        </div>
        <div className="accordion-content">
          <p>{item.answer}</p>
        </div>
      </div>
    ));
  };

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="page-container faq-container">
      <h1>Frequently Asked Questions</h1>
      <p className="faq-intro">
        We've compiled some common questions about our wedding day. If you have any other questions, please don't hesitate to contact us.
      </p>
      {userEvent === 'Houston' && (
        <>
          <div className="accordion">
            {renderHoustonFaqItems()}
          </div>
        </>
      )}

      {userEvent === 'Cancun' && (
        <>
          <div className="accordion">
            {renderCancunFaqItems()}
          </div>
        </>
      )}

      {userEvent === 'Both' && (
        <div>
          <>
            <h2 className="event-location-header">Houston FAQ</h2>
            <div className="accordion">
              {renderHoustonFaqItems()}
            </div>
          </>
          <>
            <h2 className="event-location-header">Cancun FAQ</h2>
            <div className="accordion">
              {renderCancunFaqItems()}
            </div>
          </>
        </div>
      )}
      {/* <div className="accordion">
        {faqItems.map((item, index) => (
          <div 
            className={`accordion-item ${activeIndex === index ? 'active' : ''}`} 
            key={index}
          >
            <div 
              className="accordion-header"
              onClick={() => toggleAccordion(index)}
            >
              <h3>{item.question}</h3>
              <span className="accordion-icon"></span>
            </div>
            <div className="accordion-content">
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div> */}

      <div className="contact-info">
        <h2>Still have questions?</h2>
        <p>Feel free to reach out to us at <a href="mailto:info@thealis25.com">info@thealis25.com</a></p>
      </div>
    </div>
  );
};

export default FAQ; 